import React from 'react';
import graph from '../graph';
import Create from '../Create';
import Update from '../Update';

import { useSelector } from 'react-redux';
import { hasRequiredRole } from 'helpers';
import { FormattedMessage } from 'react-intl';
import { AvatarPopover, NewMediaPopup } from 'components';
import {
  Fade,
  Card,
  Stack,
  Divider,
  IconButton,
  Typography,
  CardHeader,
  CardActions,
  CardActionArea,
} from '@mui/material';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';

export default function Model({ model, delay, checked, refetch, isAssign, selectable, handleSelect, showChildren }) {
  const { id, title, media, children } = model;

  const roles = ['superadmin', 'operator'];
  const { userInfo } = useSelector((state) => state.auth);
  const hasRole = hasRequiredRole(roles, userInfo?.roles);

  return (
    <>
      <Fade in unmountOnExit timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}>
        <Stack direction="row" alignItems="center">
          <Card
            sx={{
              width: '100%',
              position: 'relative',
              borderColor: checked && 'primary.main',
              bgcolor: checked && 'action.disabledBackground',
            }}
            variant="outlined"
          >
            <CardHeader
              sx={{ p: 1 }}
              // avatar={
              //   <NewMediaPopup id={id} model="UserCategory" collection="avatar" title={title} graph={graph}>
              //     <AvatarPopover isAssign={isAssign} sx={{ width: 48, height: 48 }} media={media[0]?.full_url} />
              //   </NewMediaPopup>
              // }
              title={
                <Stack rowGap={0.5} alignItems="flex-start">
                  <Typography variant="subtitle1">{title}</Typography>
                </Stack>
              }
              action={
                <IconButton
                  size="small"
                  disabled={children.length === 0}
                  onClick={() => showChildren(id)}
                  sx={{ bgcolor: 'action.hover', zIndex: 2 }}
                >
                  <KeyboardArrowLeftRoundedIcon fontSize="small" />
                </IconButton>
              }
            />
            <CardActions sx={{ justifyContent: 'flex-end' }}>
              {hasRole && (
                <>
                  <Update ids={id} refetch={refetch} title="update" />
                  <Create ids={id} refetch={refetch} title="create" />
                </>
              )}
            </CardActions>
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: 'absolute',
              }}
              disabled={!isAssign && !selectable}
              onClick={handleSelect}
            />
          </Card>
        </Stack>
      </Fade>
      <Divider variant="middle" />
    </>
  );
}
